export const blogArticles = [
  {
    slug: 'api-announcement',
    title: 'Orchestrating Motion at Scale with the Cartwheel API',
    summary:
      'A practical guide to generating, editing, looping, and retargeting motion programmatically at scale.',
    author: 'Andrew Carr',
    category: 'api',
    date: '2026-03-05',
    hero: { type: 'video', cdnKey: '01_api_intro.webm' },
  },
  {
    slug: 'dogstar',
    title: 'Dogstar',
    subtitle: 'episodic content at social media speed',
    summary:
      'How an Academy Award-winning director built an episodic animation pipeline at social media speed.',
    category: 'case-study',
    date: '2026-02-07',
    hero: { type: 'video', cdnKey: 'dogstar_1.webm' },
  },
  {
    slug: 'kinetic-age',
    title: 'Movement is the last moat',
    summary:
      'Why movement, not language, may be the next defining frontier for intelligent machines.',
    author: 'Andrew Carr',
    category: 'idea',
    date: '2026-02-11',
    hero: { type: 'video', cdnKey: 'move-moat-assets-03.mp4' },
  },
  {
    slug: 'move-robots',
    title: 'Non-Verbal Communication Is the Robotics Unlock',
    summary:
      'Why believable non-verbal communication matters more than task completion for robots entering our lives.',
    author: 'Andrew Carr',
    category: 'research',
    date: '2026-02-24',
    hero: {
      type: 'video',
      cdnKey: 'robot_motion_highlights_v4_disney_only.mp4',
    },
  },
  {
    slug: 'neural-rendering',
    title: 'Directing AI Video with 3D',
    summary:
      'A controllable workflow that turns precise 3D blocking into directed, stylized AI video.',
    author: 'Donald Chan',
    category: 'workflow',
    date: '2026-07-20',
    hero: { type: 'video', cdnKey: 'directing_ai_thumbnail.webm' },
  },
  {
    slug: 'psyop',
    title: 'Psyop',
    summary:
      'How an award-winning studio repaired imperfect motion capture without reshooting the performance.',
    category: 'case-study',
    date: '2026-02-07',
    hero: { type: 'image', cdnKey: 'blog_psyop1.jpg' },
  },
  {
    slug: 'scaling-laws',
    title: 'Scaling Laws for Human Motion Generation',
    summary: 'Scaling laws for human motion generation.',
    author: 'Cartwheel Team',
    category: 'idea',
    date: '2026-08-24',
    hero: { type: 'image', cdnKey: 'fig1_isoflop.png' },
  },
] as const;

export const careerSlugs = ['founding-marketing-lead'] as const;

const sharedPublicPaths = [
  '/',
  '/company',
  '/data',
  '/plugins',
  '/pricing',
  '/blog',
  ...blogArticles.map(({ slug }) => `/blog/${slug}`),
  ...careerSlugs.map((slug) => `/careers/${slug}`),
  '/privacy-policy',
  '/terms-of-use',
  '/plugin-addendum',
];

const publicProductPaths = [
  '/research',
  '/model/comic',
  '/model/swing',
  '/product/performance-capture',
  '/product/performance-generation',
  '/product/performance-editor',
  '/product/cartographer',
];

export function getPublicPrerenderPaths(): string[] {
  return [...sharedPublicPaths, ...publicProductPaths];
}

export function getPublicSitemapPaths(): string[] {
  return getPublicPrerenderPaths();
}
